module.exports = __webpack_public_path__ + "static/media/ic-search-thin-white.b64a4852.svg";